import { useInfiniteQuery, useQueryClient } from '@tanstack/react-query';
import { FEED_PAGE_SIZE, getFeed, type FeedFilter, type Post } from '../../lib/api';

export const feedKeys = {
  all: ['feed'] as const,
  list: (filter: FeedFilter) => ['feed', filter.category ?? 'all', filter.authorId ?? 'everyone'] as const,
};

export function useFeed(filter: FeedFilter, options: { pageSize?: number; enabled?: boolean } = {}) {
  const pageSize = options.pageSize ?? FEED_PAGE_SIZE;
  return useInfiniteQuery({
    queryKey: [...feedKeys.list(filter), pageSize],
    queryFn: ({ pageParam }) => getFeed(filter, pageParam, pageSize),
    initialPageParam: null as { before: string; beforeId: string } | null,
    getNextPageParam: (last: Post[]) => {
      const tail = last.at(-1);
      return last.length < pageSize || !tail ? undefined : { before: tail.createdAt, beforeId: tail.id };
    },
    enabled: options.enabled ?? true,
    refetchOnWindowFocus: true,
  });
}

/** Call after anything that changes what boards show. */
export function useRefreshBoards() {
  const queryClient = useQueryClient();
  return () =>
    Promise.all([
      queryClient.invalidateQueries({ queryKey: feedKeys.all }),
      queryClient.invalidateQueries({ queryKey: ['post'] }),
      queryClient.invalidateQueries({ queryKey: ['replies'] }),
      queryClient.invalidateQueries({ queryKey: ['nearby'] }),
    ]);
}
